import * as React from 'react'

function MinusIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12} height={1.6} viewBox="0 0 12 1.6" {...props}>
      <path data-name="- hover" d="M12 0H0v1.6h12z" transform="rotate(180 6 .8)" fill="CurrentColor" />
    </svg>
  )
}

export default MinusIcon
